<div class="sd-container--variant-white">
  @if (selectedAnalysis(); as analysisId) {
    <app-dashboard [id]="analysisId" />
  } @else {
    <h3 class="sd-headline">Dashboard</h3>

    <div class="menu">
      <div class="selection">
        <sd-6-17-1-tag
          (click)="toggleSelection(Analysis.PRESET)"
          [selected]="isSelected(Analysis.PRESET)">
          Standard
        </sd-6-17-1-tag>
      </div>

      <div class="buttons">
        <sd-6-17-1-select
          placement="bottom"
          [(value)]="sort">
          <sd-6-17-1-option [value]="Sort.LAST_USED">{{ sortText(Sort.LAST_USED) }}</sd-6-17-1-option>
          <sd-6-17-1-option [value]="Sort.OTHER">{{ sortText(Sort.OTHER) }}</sd-6-17-1-option>
        </sd-6-17-1-select>

        <sd-6-17-1-button
          style
          variant="primary"
          type="button">
          <sd-6-17-1-icon
            library="{{ iconLibrary }}"
            name="system/plus"
            slot="icon-right"></sd-6-17-1-icon>
          Neue Analyse erstellen
        </sd-6-17-1-button>
      </div>
    </div>

    <div class="list">
      @for (curItem of visible(); track $index) {
        <div
          class="sd-container--variant-white"
          (click)="openAnalysis(curItem.id)">
          <div class="sd-container sd-container--variant-primary-100"></div>
          <p class="sd-headline sd-headline--size-base">{{ curItem.title }}</p>
        </div>
      }
    </div>
  }
</div>
